import $ from 'jquery';
import {shuffleArray} from "../playUtil.es6";
import PlayAudio from "../memo/playAudio.es6";
import {arrayRandomItem} from "../arrayUtil.es6";
import {parseBoolean} from "../playUtil.es6";

require('jsrender')($);

const SET_TMPL = $.templates(`
<div class="pack-test-set">
    <div class="pack-test-set__title">{{>~l18n.get('packTest.qsYN')}}</div>
    <div class="pack-test-set__yn">
        <ul class="pack-test-set__yn-questions">
        {{for questions}}
            <li class="pack-test-set__yn-question pb-3" data-id="{{:id}}">
                <div class="row no-gutters">
                     <div class="col-md-5">
                        <div class="row no-gutters">
                            {{if question.audio}}
                            <div class="col-auto mr-3">
                                <audio src="{{attr:question.audio}}"></audio>
                                <a class="btn btn-light" data-handler="playAudio"><span class="fal fa-volume"></span></a>
                            </div>
                            {{/if}}
                            {{if question.image}}
                            <div class="col-auto mr-3 pack-test-set__yn-image"><img src="{{attr:question.image}}"/></div>
                            {{/if}}
                            <div class="col fl-tt-{{:question.textType}}">{{if question.textType == 'html'}}{{:question.text}}{{else}}{{> question.text}}{{/if}}</div>
                        </div>
                    </div>
                    <div class="col">
                        <span class="pack-test-set__yn-question-delimiter">→</span>
                    </div>
                     <div class="col-md-5">
                        <div class="row no-gutters">
                            {{if answer.audio}}
                            <div class="col-auto mr-3">
                                <audio src="{{attr:answer.audio}}"></audio>
                                <a class="btn btn-light" data-handler="playAudio"><span class="fal fa-volume"></span></a>
                            </div>
                            {{/if}}
                            {{if answer.image}}
                            <div class="col-auto mr-3 pack-test-set__yn-image"><img src="{{attr:answer.image}}"/></div>
                            {{/if}}
                            <div class="col fl-tt-{{:answer.textType}}">{{if answer.textType == 'html'}}{{:answer.text}}{{else}}{{> answer.text}}{{/if}}</div>
                        </div>
                    </div>
                </div>
                
                <div class="mt-3 mb-3 text-center pack-test-set__yn-selection">
                   <div class="custom-control custom-radio custom-control-inline">
                        <input class="custom-control-input" id="yn_answer_{{:id}}_y" type="radio" name="yn_answer_{{:id}}" value="true">
                        <label class="custom-control-label" for="yn_answer_{{:id}}_y">{{>~l18n.get('packTest.qsYN.true')}}</label>
                    </div>
                   <div class="custom-control custom-radio custom-control-inline">
                        <input class="custom-control-input" id="yn_answer_{{:id}}_n" type="radio" name="yn_answer_{{:id}}" value="false">
                        <label class="custom-control-label" for="yn_answer_{{:id}}_n">{{>~l18n.get('packTest.qsYN.false')}}</label>
                    </div>
                </div>
            </li>
        {{/for}}
        </ul>
    </div>
</div>`);

const ANSWER_TMPL = $.templates(`
<span class="pack-test-set__yn-question-expected fl-keep-nl">{{>~l18n.get('packTest.qsYN.expected')}} {{>expectedText}}.</span>        
`);


export default class TestTrueFalse {
    constructor(props) {
        this.testList = props.testList;
        this.sideAdapter = props.sideAdapter;
        this.l18n = props.l18n;
        this.checkers = props.checkers;
        this.test = props.test;
        this.cards = props.cards;
    }

    create(tasks) {
        const texts = this.sideAdapter;

        const questions = tasks.map(item => {
            const displayTrue = Math.random() > .5;
            let answer;
            if (displayTrue) {
                answer = item;
            } else {
                answer = arrayRandomItem(this.cards);
            }
            const expected = answer.id === item.id;
            const expectedText = expected
                ? this.l18n.get('packTest.qsYN.true')
                : this.l18n.get('packTest.qsYN.false');
            return {id: item.id, question: texts.question(item), answer: texts.answer(answer), expected: expected, expectedText: expectedText};
        });
        shuffleArray(questions);

        questions.forEach(q => {
            this.checkers.push(() => {
                const view = this.testList.find(`.pack-test-set__yn-question[data-id=${q.id}]`);
                const radios = view.find(`input[name=yn_answer_${q.id}]`);
                const userAnswer = parseBoolean(radios.filter(':checked').val());
                if (userAnswer === q.expected) {
                    view.addClass('pack-test-set__yn-question--correct');
                    this.test.correctAnswers += 1;
                } else {
                    view.addClass('pack-test-set__yn-question--wrong');
                    view.prepend(ANSWER_TMPL.render(q, this));
                }

                radios.each(function () {
                    const radio = $(this), radioValue = parseBoolean(radio.attr('value'));
                    if (radioValue === userAnswer) {
                        if (radioValue === q.expected) {
                            radio.closest('.custom-radio').addClass('custom-radio-correct');
                        } else {
                            radio.closest('.custom-radio').addClass('custom-radio-wrong');
                        }
                    } else {
                        radio.closest('div').remove();
                    }
                });

                // disable user click on label
                radios.remove();
            });
        });

        const html = $(SET_TMPL.render({questions: questions}, this));

        html.find('a[data-handler=playAudio]').each(function (e) {
            const anchor = $(this);
            PlayAudio.initSingleSide(anchor, false, anchor.closest('div'));
        });

        this.testList.append(html);
    }
}